import CryptoJS from 'crypto-js';

// import lib
import config from '../config';
export const encodedata = (data) => {
    let encrpteddata = CryptoJS.AES.encrypt(JSON.stringify(data), config.CRYPTO_SECRET_KEY).toString()
    return encrpteddata;
  
  }
  
  export const decodedata = (data) => {
    let dataaaa = CryptoJS.AES.decrypt(data, config.CRYPTO_SECRET_KEY);
    console.log("JSON.parse(dataaaa.toString(enc.Utf8))", dataaaa, JSON.parse(dataaaa.toString(CryptoJS.enc.Utf8)));
    return JSON.parse(dataaaa.toString(CryptoJS.enc.Utf8))
  
  };